export function giveawayThumbUrl(row) {
  const v = row?.giveaway?.image;
  return typeof v === "string" ? v.trim() : "";
}

function sessionStatus(row) {
  return String(row?.participation?.session_status || "").trim();
}

function canContinue(row) {
  const p = row?.participation;
  if (!p) return false;
  if (p.can_continue === false) return false;
  const st = sessionStatus(row);
  if (!st || st === "in_progress") return true;
  if (st === "pending_review") return true;
  return false;
}

export function participationsActive(rows) {
  return (rows || []).filter((r) => canContinue(r));
}

export function participationsHistory(rows) {
  return (rows || []).filter((r) => {
    const st = sessionStatus(r);
    return st === "paid" || st === "payout_completed" || st === "payout_sent" || st === "cashback_paid";
  });
}

export function participationsStale(rows) {
  return (rows || []).filter((r) => {
    const st = sessionStatus(r);
    if (canContinue(r)) return false;
    if (participationsHistory([r]).length) return false;
    return st === "rejected" || st === "pending_review" || !!st;
  });
}

export function historyBadgeClass(participation, styles) {
  const st = String(participation?.session_status || "");
  if (st === "rejected") return styles.badgeDanger || "";
  if (st === "pending_review") {
    if (participation?.review_approved) return styles.badgeSuccess || "";
    return styles.badgeWarn || "";
  }
  if (st === "paid" || st.includes("payout") || st === "cashback_paid") return styles.badgeSuccess || "";
  return styles.badgeMuted || "";
}
